// extracted by mini-css-extract-plugin
module.exports = {"root":"ScreenToolbarAction_root","icon":"ScreenToolbarAction_icon","label":"ScreenToolbarAction_label"};